<template>
  <div>
    <div>
      <b-row>
        <b-col align-self="center">
          <b-form-group label-align="right" :label="$t('Service name')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled>
            <b-form-input type="text" v-model="currentService.service_name"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Charge time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <flat-picker :key="rerenderStartDate"
            @onDateChanged="(unixDate) => {onceService.discount_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(onceService.discount_date ? onceService.discount_date : new Date()/1000 ).toDate())}"
            />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="onceService.cost_coef"/>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <modal-ok-cancel @save="saveServiceLink" @cancel="hideSelectService" />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null,
    tariffLinkId: 0
  },
  data () {
    return {
      rerenderStartDate: 0,
      onceService: {
        'user_id': 0,
        'account_id': 0,
        'discount_date': moment().unix(),
        'service_id': 0,
        'cost_coef': 100,
        'tplink_id': 0,
        'slink_id': 0
      }
    }
  },
  methods: {
    saveServiceLink () {
      this.onceService.cost_coef = this.onceService.cost_coef / 100
      this.onceService.tplink_id = this.tariffLinkId ? this.tariffLinkId : 0
      if (this.isEdit) {
        this.onceService.slink_id = this.currentService.service_link_id
      } else {
        this.onceService.account_id = this.selectedAccount
        this.onceService.user_id = this.currentUser.user_id
        this.onceService.service_id = this.currentService.service_id
      }
      let response = this.isEdit
        ? this.$store.dispatch('Users/UPDATE_ONE_TIME_SERVICE_LINK', this.onceService)
        : this.$store.dispatch('Users/CREATE_ONE_TIME_SERVICE_LINK', this.onceService)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          this.onceService.cost_coef = this.onceService.cost_coef * 100
        } else {
          this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
          this.hideSelectService()
          this.$root.$emit('makeToasts')
        }
      })
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    }
  },
  mounted () {
    if (this.isEdit) {
      this.$store.dispatch('Users/GET_ONE_TIME_SERVICE_LINK', this.currentService.service_link_id).then(response => {
        this.onceService = this.$store.getters['Users/ONE_TIME_SERVICE_LINK']
        this.onceService.cost_coef = this.onceService.cost_coef * 100
        this.rerenderStartDate += 1
      })
    }
    if (this.currentService.addByDefault) {
      this.saveServiceLink()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formOnce.vue